<template>
    <div >
        <!--banner-->
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/picture/banner/A6.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 联系我们 -->
                        {{ $t('header.mb_contactUs') }}
                    </h1>
                    <h3>
                        <!-- 坚持自主创新，赋能中国工业创新发展 -->
                        {{ $t('about.about_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                             <!-- 首页 -->
                            {{ $t('header.home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <!-- 联系我们 -->
                            {{ $t('header.mb_contactUs') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
     
        <!-- 行业业绩 -->
        <section id="company_introduction" class="we-help" style="padding: 80px 0;background-color: #f9fafc;">
            <div class="counter-one__bg" >
            </div>
            <div class="container">
            <div class="row">
                <div class="col-xl-12">
                <ul class="list-unstyled counter-one__list">
                    <li class="counter-one__single wow fadeInUp" data-wow-delay="100ms">
                    <div class="counter-one__icon">
                        <span class="icon-work"></span>
                    </div>
                    <h3 class="odometer" data-count="10">10</h3><span class="odo-plus">+</span>
                    <p class="counter-one__title">
                         <!-- 合作行业 -->
                         {{ $t('about.about_counter_industry') }}
                    </p>
                    <div class="counter-one__shadow">INDUSTRY</div>
                    </li>
                    <li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
                    <div class="counter-one__icon">
                        <span class="icon-like"></span>
                    </div>
                    <h3 class="odometer" data-count="560">560</h3><span class="odo-plus">+</span>
                    <!-- <span class="counter-one__plus">+</span> -->
                    <p class="counter-one__title">
                         <!-- 合作客户 -->
                        {{ $t('about.about_counter_client') }}
                    </p>
                    <div class="counter-one__shadow">CLIENT</div>
                    </li>
                    <li class="counter-one__single wow fadeInUp" data-wow-delay="200ms">
                    <div class="counter-one__icon">
                        <span class="icon-technical-support"></span>
                    </div>
                    <h3 class="odometer" :data-count="equipmentNumer">{{ equipmentNumer }}</h3><span class="odo-plus">{{ $t('about.about_ten') }}+</span>
                    <p class="counter-one__title">
                         <!-- 入网设备 -->
                        {{ $t('about.about_counter_equipment') }}
                    </p>
                    <div class="counter-one__shadow">EQUIPMENT</div>
                    </li>
                    <li class="counter-one__single wow fadeInUp" data-wow-delay="300ms">
                    <div class="counter-one__icon">
                        <span class="icon-user"></span>
                    </div>
                    <h3 class="odometer" data-count="260">260</h3><span class="odo-plus">+</span>
                    <p class="counter-one__title">
                         <!-- 核心研发 -->
                        {{ $t('about.about_counter_employee') }}
                    </p>
                    <div class="counter-one__shadow">EMPLOYEE</div>
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </section>
      
        <!-- 联系我们 -->
        <section id="company_contact" class="contact-details">
            <div class="container">
                <div style="width: 100%;">
                    <div style="width: 100%;">
                        <div class="section-title text-center">
                            <div class="section-title__tagline-box">
                                <span class="section-title__tagline">Contact with us</span>
                                <div class="section-title-shape">
                                    <img src="static/image/section-title-shape.png" alt="">
                                </div>
                            </div>
                            <h2 class="section-title__title">
                                <!-- 公司地址 -->
                                {{ $t('about.company_address') }}    
                            </h2>
                        </div>
                        <div id="containerG" style="height: 300px;width: 100%;">
                            <img src="static/picture/about/about.png" style="width: 100%; height: 100%;">
                        </div>
                    </div>
                    <div style="width: 100%;">
                        <div class="contact-details__right" style="margin-top: 30px;">
                            <div class="section-title text-center">
                                <div class="section-title__tagline-box">
                                    <span class="section-title__tagline">Contact with us</span>
                                    <div class="section-title-shape">
                                        <img src="static/image/section-title-shape.png" alt="">
                                    </div>
                                </div>
                                <h2 class="section-title__title">
                                    <!-- 联系我们 -->
                                      {{ $t('about.about_contact_title') }}
                                </h2>
                            </div>
                            <p class="contact-details__text">
                                <!-- 我们基于创造性的思想与先进的技术，创新和运营高客户价值的产品与服务，帮助客户实现发展目标，进而推动智能制造进步。 -->
                                {{ $t('about.about_contact_text') }}   
                            </p>
                            <ul class="list-unstyled contact-details__info">
                                <li>
                                    <div class="icon">
                                        <span class="icon-pin"></span>
                                    </div>
                                    <div class="text" style="width: calc(100% - 80px);">
                                        <p>
                                            <!-- 总部地址 -->
                                            {{ $t('about.about_contact_address_label') }} 
                                        </p>
                                        <span style="margin-left: 5px;">
                                             <!-- 济南市高新开发区伯乐路282号 -->
                                             {{ $t('about.about_contact_address_value') }} 
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="icon-telephone"></span>
                                    </div>
                                    <div class="text">
                                        <p>
                                             <!-- 销售热线 -->
                                             {{ $t('about.about_contact_phone_label') }}   
                                        </p>
                                        <!-- href="tel:4000531772" -->
                                        <p><a >132-0531-8830</a> <span style="margin-left: 5px;">
                                             <!-- 王经理 -->
                                             {{ $t('about.about_contact_phone_manager_wang') }} 
                                        </span></p>
                                        <p><a >183-5314-7789</a> <span style="margin-left: 5px;">
                                             <!-- 许经理 -->
                                             {{ $t('about.about_contact_phone_manager_xu') }}  
                                        </span></p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="icon-email"></span>
                                    </div>
                                    <div class="text">
                                        <p>E-mail</p>
                                        <!-- href="mailto:aotaimarket@aotaidianqi.com" -->
                                        <a >qunkong@aotaidianqi.com</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script >
export default {
    name: 'mbAbout',
    data () {
        return {
            solutionList: {},
               equipmentNumer: 22,
        }
    },
     created() {
        if(this.$i18n.locale == 'zh_CN') {
            this.equipmentNumer = 22
        } else if( this.$i18n.locale == 'en_US') {
           this.equipmentNumer = 220
        }
    },
    mounted () {
       
       
        // var map = new BMapGL.Map('containerG');
        // map.centerAndZoom(new BMapGL.Point(117.140134, 36.673283), 17);
        // var marker = new BMapGL.Marker(new BMapGL.Point(117.140134, 36.673283));
        // map.addOverlay(marker); // 增加点

         this.$nextTick(() => {
        // Odometer 是 index.html 里全局引入的，挂在 window 上
        if (typeof window.Odometer === 'undefined') return;
        
        $(".odometer").each(function () {
            var el = this;
            var target = parseFloat($(el).attr("data-count")) || 0;
            
            // 手动创建 Odometer 实例（它会劫持 innerHTML setter）
            var od = new window.Odometer({
                el: el,
                value: 0,           // 从 0 开始
                duration: 2000,     // 动画时长 2 秒
                animation: 'count'   // count = 数字一个一个跳；slide = 滚轮滑动
            });
            
            // 下一帧触发滚动到目标值
            requestAnimationFrame(function () {
                od.update(target);   // ← update() 才会播放动画！
            });
        });
    });

    },
    beforeDestroy() {
        $(window).unbind('scroll')
    },
    methods: {
     
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}
.counter-one__title{
	margin-top: 30px;
}
.counter-one__single h3{
	font-size: var(--font-size-40);
}

/* 加个样式 */
.odo-plus { 
    font-size: var(--font-size-24); 
    font-weight: bold; 
    margin-left: 2px; 
    vertical-align: middle;
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    /* font-size: var(--font-size-16); */
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}

.nav-wrapper li a {
    display: block;
    color: var(--notech-black);
    text-align: center;
    line-height: 78px;
    height: 78px;
    text-decoration: none;
}
.nav-wrapper li a:hover {
    color: #097cf2;
    border-bottom: solid 2px #097cf2;
}
.counter-one__single {
    flex: 0 0 50%;
    width: 50%;
    margin-bottom: 0px;
    padding: 5px;
}
</style> 